// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f7addd17","389":"69a85166","394":"cf80b35d","453":"554092ed","732":"b97dbf2f"}[chunkId] + ".chunk.js";
};